import React from 'react'
import {Link as RRLink} from 'react-router-dom'

export const Link = props => (
  <RRLink {...props} />
)
Link.displayName = 'Link'
